import { render, staticRenderFns } from "./c-widget@.vue?vue&type=template&id=35f50006&scoped=true&"
import script from "./c-widget@.vue?vue&type=script&lang=ts&"
export * from "./c-widget@.vue?vue&type=script&lang=ts&"
import style0 from "./c-widget@.vue?vue&type=style&index=0&id=35f50006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f50006",
  null
  
)

export default component.exports